import { FETCH_CAMPAIGN, FETCH_CAMPAIGN_SUCCESS } from '../constants';
import config from '../../config';
import { checkStatus, handleRequestError } from '../utils/helpers';

// eslint-disable-next-line import/prefer-default-export
export const fetchCampaign = (campaignId, source, customerId) => (dispatch) => {
  dispatch({ type: FETCH_CAMPAIGN });
  return fetch(`${config.url}/campaign/${campaignId}/${source}/${customerId || ''}`)
    .then(checkStatus)
    .then(response =>
      dispatch({ type: FETCH_CAMPAIGN_SUCCESS, payload: response })
    )
    .catch(handleRequestError(dispatch));
};



// WEBPACK FOOTER //
// ./src/app/campaign/actions.js